import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Link } from "gatsby";
import MyLayout from "../components/header";
 

const ProjectDoc = () => {

    const data = useStaticQuery(graphql`
    query   {
      nodePage(path: { alias: { eq: "/project-document-cllmp-mlamp" } }) {
        title
        body {
          processed
        }
      }
    }
  `);

  const { title, body } = data.nodePage;

  const tabs = [
    { label: 'MLAMP   DOCUMENT', content: <div className="my-8">  <p dangerouslySetInnerHTML={{  __html:body[1].processed }} /></div> },
    { label: 'CLLMP   DOCUMENT', content: <div className="my-8">  <p dangerouslySetInnerHTML={{  __html:body[0].processed }} /></div> },
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleSelect = (index) => {
    setSelectedIndex(index);
  };

  // Inline styles for active tab
  const activeTabStyle = {
    background: "#0d9489",
    color: "#fff",
    // Adjust the color as needed
  }

  return (
    <MyLayout>
       <nav class="2xl:mt-20 xl:mt-24 lg:mt-[90px] md:mt-[70px] mt-[70px] w-full flex px-5 py-3 text-gray-700 border border-gray-200 rounded-lg bg-gray-50" aria-label="Breadcrumb">
  <ol class="inline-flex items-center space-x-1 md:space-x-3">
    <li class="inline-flex items-center">
      <Link to="/" class="inline-flex items-center text-sm poppins-regular text-gray-700 ">
        <svg class="w-3 h-3 mr-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
          <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
        </svg>
        Home
      </Link>
    </li>
    <li>
      <div class="flex items-center poppins-semibold">
        <svg class="w-3 h-3 mx-1 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
        </svg>
        <Link  to="/project_doc" class="ml-1 text-sm poppins-semibold text-gray-700   md:ml-2 ">Project Document</Link>
      </div>
    </li>
  
  </ol>
</nav>

        <div className="mt-26 3xl:mx-52 2xl:mx-32 xl:mx-32 lg:mx-32 md:mx-32 mx-2 my-8 ">
               <Tabs defaultIndex={0} onSelect={handleSelect}>
                 <div className="flex flex-col justify-start lg:flex-row md:flex-col lg:justify-between md:justify-between">
                   {" "}
                   <TabList className="flex gap-8 mb-5 lg:justify-start md:justify-start justify-center">
                     {tabs.map((tab, index) => (
                       <Tab
                         key={index}
                         className="bg-[#E0E0E0] p-6 text-center px-5 cursor-pointer py-3  text-[#0d9489] hover:bg-[#B0B0B0] hover:text-black w-56 poppins-regular"
                         selectedClassName="border-gray-500"
                         style={index === selectedIndex ? activeTabStyle : {}}
                         disabledClassName="opacity-50 cursor-not-allowed"
                       >
                         {tab.label}
                       </Tab>
                     ))}
                   </TabList>
                   
                 </div>
                 {tabs.map((tab, index) => (
                   <TabPanel
                     key={index}
                     className={`   ${index !== selectedIndex ? "hidden" : ""}`}
                   >
                     <div
                       className="items-center  "
                       style={{ alignItems: "center" }}
                     >
                       {tab.content}
                     </div>
                   </TabPanel>
                 ))}
               </Tabs>
             </div>
    </MyLayout>
  );
};

export default ProjectDoc;
